module.exports = __webpack_public_path__ + "img/avatar-border.1c8fc1de.svg";